import store from './store'
import BubbleMenu from './components/b-menu'
import StoreHelper from './store/helper'

import api from './api'
import { mounted, destroyed } from './directives'

const bubbleMenu = {
  install (Vue, options) {
    const defaultName = 'bubbleMenu'
    Object.defineProperty(Vue.prototype, '$'.concat(options.name || defaultName), {
      get () { return api }
    })

    // Declare library directives
    Vue.directive(mounted.id, mounted.definition)
    Vue.directive(destroyed.id, destroyed.definition)

    // Define store as observable to ensure component reactivity on store changes. (vue.js 2.6 required)
    Vue.observable(store)

    // Object.defineProperty(Vue.prototype, '$bubbleMenu', {
    //   get () { return store.actions }
    // })

    Vue.component(options.name || defaultName, BubbleMenu)

    if (options.router) {
      StoreHelper.setRouter(options.router)
    }

    if (options.initialRoute) {
      StoreHelper.setInitialRoute(options.initialRoute)
    }

    if (options.itemsPerPage) {
      StoreHelper.setItemsPerPage(options.itemsPerPage)
    }

    if (options.topRightComponent) {
      StoreHelper.setTopRightComponent(options.topRightComponent)
    }

    if (options.menuItemBubbleContentComponent) {
      StoreHelper.setMenuItemBubbleContentComponent(options.menuItemBubbleContentComponent)
    }

    if (options.menuItemBubbleLabelComponent) {
      StoreHelper.setMenuItemBubbleLabelComponent(options.menuItemBubbleLabelComponent)
    }

    if (options.mainBubbleContentComponent) {
      StoreHelper.setMainBubbleContentComponent(options.mainBubbleContentComponent)
    }

    if (options.menuItemBubbleSettings) {
      StoreHelper.setMenuItemBubbleSettings(options.menuItemBubbleSettings)
    }

    if (options.menuMainBubbleSettings) {
      StoreHelper.setMenuMainBubbleSettings(options.menuMainBubbleSettings)
    }

    if (options.breadcrumb) {
      StoreHelper.setBreadcrumbSettings(options.breadcrumb)
    }

    if (options.pagination) {
      StoreHelper.setPaginationSettings(options.pagination)
    }

    if (options.backButton) {
      StoreHelper.setBackButtonSettings(options.backButton)
    }

    StoreHelper.loadSettings()
  }
}

export default bubbleMenu

let GlobalVue = null
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue
}
if (GlobalVue) {
  GlobalVue.use(bubbleMenu)
}
